import { render } from "./ModalCreditCard.vue?vue&type=template&id=4553f6af&scoped=true"
import script from "./ModalCreditCard.vue?vue&type=script&lang=js"
export * from "./ModalCreditCard.vue?vue&type=script&lang=js"

import "./ModalCreditCard.vue?vue&type=style&index=0&id=4553f6af&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4553f6af"]])

export default __exports__